import { TextField, styled } from '@mui/material';
import React from 'react';

const RightAlignedTextField = (props) => {
  const StyledTextField = styled(TextField)({
    '& label': {
      right: '.5em',
      left: 'auto',
    },
  });
  return (
    <React.Fragment>
      <div dir="rtl">
        <StyledTextField
          {...props}
          sx={{
            height: '40px !important',
            maxHeight: '40px',
          }}
          InputProps={{
            style: {
              height: '40px !important',
              maxHeight: '40px',
            },
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default RightAlignedTextField;
